<mat-form-field appearance="outline">
    <mat-label>{{label}}</mat-label>
    <mat-select [formControl]="fc" (selectionChange)="setDateRange($event.value)" placeholder="All">
      <mat-option>All</mat-option>
      <mat-option [value]="'notZero'">Amount is not 0</mat-option>
      <mat-option [value]="'belowZero'">Amount below 0</mat-option>
      <mat-option [value]="'aboveZero'">Amount above 0</mat-option>
      <mat-option [value]="'custom'">Custom</mat-option>
    </mat-select>
  </mat-form-field>